package com.essntl.core.quickbooks.data

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class QuickbooksInvoiceRequest(
    @SerialName("DueDate")
    val dueDate: String,
    @SerialName("Line")
    val line: List<Line>,
    @SerialName("CustomerRef")
    val customerRef: CustomerRef,
    @SerialName("CustomerMemo")
    val customerMemo: CustomerMemo? = null,
    @SerialName("DocNumber")
    val docNumber: String,
    @SerialName("CustomField")
    val customField: List<CustomField>,
) {
    @Serializable
    data class Line(
        val DetailType: String,
        val Amount: Double? = null,
        val SalesItemLineDetail: SalesItemLineDetail,
        val Description: String?,
    ) {
        companion object {
            const val SALES_ITEM_LINE_DETAIL = "SalesItemLineDetail"
            const val SALES_TOTAL_LINE_DETAIL = "SubTotalLineDetail"
        }
    }

    @Serializable
    data class SalesItemLineDetail(
        val ItemRef: ItemRef,
        val Qty: Int? = null,
        val UnitPrice: Double? = null,
        val ServiceDate: String? = null,    // formatted as "2024-12-20"
    )

    @Serializable
    data class ItemRef(
        val name: String? = null,
        val value: String,
    )

    @Serializable
    data class CustomerRef(
        val value: String,
    )

    @Serializable
    data class CustomerMemo(
        val value: String,
    )

    @Serializable
    data class CustomField(
        val DefinitionId: String,
        val Name: String,
        val Type: String,
        val StringValue: String,
    )
}